<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/invoice/"+editingModel+"/retry-payment"' @onError='getInvoice'>
        <template #title>Retry failed payment</template>

        <template v-if='invoice != null' #default="{ saving, errors }">
            <div class='flex justify-between items-start text-15'>
                <p class='font-semibold pb-2'>Payment history</p>
                <button class='link-text text-13' type='button' @click='showAll = !showAll'>{{ showAll ? 'Show last payment' : 'Show all payments' }}</button>
            </div>

            <div class='grid grid-cols-1 gap-y-4 border-b border-grey-500 pb-4'>
                <template v-for='(payment, index) in invoice.payments'>
                    <div class='text-14' v-if='showAll ? true : (index+1 == invoice.payments.length)'>
                        <p>Payment attempt {{ index+1 }} taken on {{ $moment(payment.charge_at).format('DD/MM/YYYY HH:mm') }}</p>
                        <p class='text-grey-900'>{{ payment.fail_message }} {{ payment.seller_message }}</p>
                        <PaymentMethodTable :paymentMethod='payment.payment_method' />
                    </div>
                </template>
            </div>
            
            <p class='text-15 font-semibold mt-6'>Payment breakdown</p>

            <div class='text-15 flex items-center justify-between py-4'>
                <p>Sub total</p>
                <p>{{ $help.dp(invoice.sub_total) }}</p>
            </div>
            <div class='text-15 flex items-center justify-between border-y border-grey-500 py-4'>
                <p>VAT</p>
                <p>{{ $help.dp(invoice.tax) }}</p>
            </div>
            <div class='text-15 flex items-center justify-between py-4'>
                <p>Total</p>
                <p>{{ $help.dp(invoice.total) }}</p>
            </div>

            <SelectCard 
                v-model:value="value.card_id"
                :disabled="saving"
                :options="cards"
                valueKey="id"
                class="mt-2"
                :hideAddNewCard='true'
            />

            <!-- <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">Are you sure you want to do this?</p>
            </InputCheckbox> -->

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Retry payment
				</ButtonSaving>

                <button class="button-purple col-span-2 lg:col-span-1 h-12 default" @click='$emit("close")'>Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                invoice: null,
                cards: null,
                showAll: false,
                value: {
                }
            }
        },

        created() {
            this.getInvoice()
        },

        methods: {
            getInvoice() {
                this.$axios.get('/admin/invoices/' + this.editingModel)
                    .then(res => {
                        this.invoice = res.invoice
                        this.cards = res.cards
                    })
            }
        },

        computed: {
        }
    }
</script>